module.exports = __webpack_public_path__ + "local_expert.a1935680be5a0ef26d88ca614037af68.svg";